import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import CompanyInformation from './CompanyInformation';

const useStyles = theme => ({
    root: {
        position: 'relative',
        // top: '-48px',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    },
    textfield: {
        margin: theme.spacing(1),
        width: '250px',
        backgroundColor: '#ffffff'
    }
    ,
    emailIdField: {
        margin: theme.spacing(1),
        width: '520px',
        backgroundColor: '#ffffff'
    }
});

class CreateAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            comapnyInformation: false,
            firstName: '',
            lastName: '',
            emailId: '',
            password: '',
            phoneNumber: '',
            username: '',
            confirmPassword: '',
            formValid: false
        }
    }

    async componentDidMount() {

    }

    handleFormChange = (event) => {
        this.setState({
            formValid: false,
            [event.target.id]: event.target.value,
        }, () => {
            this.handleFormValidation();
        });
    };

    handleFormValidation = () => {
        const specialCharacters = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (this.state.firstName && this.state.lastName && this.state.emailId && this.state.phoneNumber.length === 10 && this.state.username && ( this.state.password === this.state.confirmPassword ) &&
            /\d/.test(this.state.password) && specialCharacters.test(this.state.password) && this.state.password.length > 7 && /[A-Z]/.test(this.state.password)) {
            this.setState({ formValid: true });
        } else if (this.state.isFormValidSave) {
            this.setState({ formValid: false });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                {this.state.comapnyInformation
                    ? <CompanyInformation firstName={this.state.firstName} lastName={this.state.lastName} emailId={this.state.emailId} password={this.state.password} phoneNumber={this.state.phoneNumber} username={this.state.username} />
                    : <Grid container className={classes.root}>
                        <Box style={{ height: '50px', display: 'flex', flexDirection: 'row', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ color: '#47a0c4', fontSize: '1.3rem' }} >
                                1. Create Account
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                2. Company Information
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                3. Choose a Subscription
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                4. Complete
                            </Typography>
                        </Box>

                        <Box style={{ height: '600px', display: 'flex', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Grid>
                                <Grid container style={{ justifyContent: 'center' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                        Create an OpenCampground Account
                                    </Typography>
                                </Grid>
                                <Grid container>
                                    <TextField id="firstName" required label="First Name" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="lastName" required label="Last Name" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="emailId" required label="Email Address" type="email"
                                        className={classes.emailIdField} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="username" required label="Username" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="phoneNumber" required label="Phone Number" type="number"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="password" required label="Password" type="password"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="confirmPassword" required label="Confirm Password" type="password"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container style={{ justifyContent: 'left' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '0.9rem' }} >
                                        - Must be 8 characters in length
                                    </Typography>
                                </Grid>
                                <Grid container style={{ justifyContent: 'left' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '0.9rem' }} >
                                        - Must contain at lease one Uppercase letter
                                    </Typography>
                                </Grid>
                                <Grid container style={{ justifyContent: 'left' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '0.9rem' }} >
                                        - Must contain at least one Number
                                    </Typography>
                                </Grid>
                                <Grid container style={{ justifyContent: 'left' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '0.9rem' }} >
                                        - Must contain at least one special character
                                    </Typography>
                                </Grid><br />
                                <Grid container style={{ justifyContent: 'right' }}>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ comapnyInformation: true }) }} disabled={!this.state.formValid}>Next </Button>
                                </Grid><br />
                            </Grid>
                        </Box>
                    </Grid>
                }
            </>
        );
    };
};

export default withStyles(useStyles)(CreateAccount);